import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Shield, TrendingUp, Award } from 'lucide-react';
import { WHATSAPP_LINK } from '../lib/constants';
export function FinalCTA() {
  return <section className="bg-mobal-black py-24 md:py-32" data-id="element-118">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center max-w-5xl" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-120">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-mobal-white mb-6 leading-tight uppercase tracking-tight" data-id="element-121">
            ¿TENÉS UN PROBLEMA DE PLAGAS{' '}
            <span className="text-mobal-green" data-id="element-122">AHORA?</span>
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 font-body max-w-3xl mx-auto" data-id="element-123">
            Te respondemos rápido y te damos una solución hoy mismo.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mb-20 flex flex-col items-center" data-id="element-124">
          <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="w-full md:w-auto inline-flex items-center justify-center bg-mobal-green text-mobal-black font-black py-5 px-12 rounded-lg hover:bg-[#b5ff33] transition-all min-h-[64px] text-xl md:text-2xl shadow-[0_0_20px_rgba(163,255,0,0.2)] hover:shadow-[0_0_30px_rgba(163,255,0,0.4)]" data-id="element-125">
            SOLICITAR PRESUPUESTO
          </a>
          <p className="mt-4 text-gray-400 font-body" data-id="element-126">
            Te respondemos lo antes posible por{' '}
            <span className="text-mobal-green font-medium" data-id="element-127">WhatsApp</span>.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-6 border-t border-gray-800 pt-16" data-id="element-128">
          <div className="flex flex-col items-center text-center gap-3" data-id="element-129">
            <ShieldCheck className="w-8 h-8 text-mobal-green mb-1" data-id="element-130" />
            <h4 className="font-bold text-mobal-white text-sm md:text-base uppercase" data-id="element-131">
              EVITÁ CLAUSURAS
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-132">
              Cumplí con las normativas sanitarias.
            </p>
          </div>

          <div className="flex flex-col items-center text-center gap-3" data-id="element-133">
            <Shield className="w-8 h-8 text-mobal-green mb-1" data-id="element-134" />
            <h4 className="font-bold text-mobal-white text-sm md:text-base uppercase" data-id="element-135">
              IMAGEN QUE GENERA CONFIANZA
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-136">
              Ambientes limpios y seguros para tus clientes.
            </p>
          </div>

          <div className="flex flex-col items-center text-center gap-3" data-id="element-137">
            <TrendingUp className="w-8 h-8 text-mobal-green mb-1" data-id="element-138" />
            <h4 className="font-bold text-mobal-white text-sm md:text-base uppercase" data-id="element-139">
              MENOS RIESGOS, MÁS PRODUCTIVIDAD
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-140">
              Evitá pérdidas y problemas en tu operación.
            </p>
          </div>

          <div className="flex flex-col items-center text-center gap-3" data-id="element-141">
            <Award className="w-8 h-8 text-mobal-green mb-1" data-id="element-142" />
            <h4 className="font-bold text-mobal-white text-sm md:text-base uppercase" data-id="element-143">
              GARANTÍA DE SERVICIO
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-144">
              Trabajo profesional con calidad asegurada.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}